import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { LoyaltyCardAlV1Component } from "abs-ngx-library/src/lib/loyalty-card";
import { BehaviorSubject } from 'rxjs';
import { AemService, IConfigObj, LoyaltyCarouselService, CommonService, AuthModalService } from 'abs-ngx-library/src/lib/core';

declare let $: any;
declare let slick: any;

@Component({
  selector: 'deals-carousel',
  templateUrl: './deals-carousel.component.html',
  styleUrls: ['./deals-carousel.component.scss']
})
export class DealsCarouselComponent implements OnInit {

  @Input() carouselData: any;
  @Input() logoProps: any = {};
  public coupons: any = [];
  @Input() carouselBehaviour: string = "";
  @Input() configObj: IConfigObj = {
    appName: '',
    programType: '',
    applyDiscoveryStyles:false
  };
  @Output() openFlyOutEvent = new EventEmitter<any>();
  @Output() viewAllClickEvent = new EventEmitter<any>();
  @ViewChildren(LoyaltyCardAlV1Component)
  couponCardChildComponents: QueryList<LoyaltyCardAlV1Component>;
  @ViewChild('nextRedesignButton',{static:false, read: ElementRef}) nextRedesignButtonRef;
  @ViewChild('prevRedesignButton',{static:false, read: ElementRef}) prevRedesignButtonRef;

  _childComponentsReady = new BehaviorSubject<boolean>(false);
  public disableSlickUnifiedBtnUI: boolean = false;
  public isP13nCoupon: boolean = false;
  private wrapper: any;
  public isLoyaltyCardCarouselRedesignDisabled: boolean = true;
  public adaAnnouncement = '';
  public announcementTimeout;
  public isAdaAnnouncementEnabled = false;
  public showRedesignButtons = true;
  public isNextButtonDisabled = false;
  public isPrevButtonDisabled = false;


  constructor(
    public elementRef: ElementRef,
    private _aemService: AemService,
    private _carouselService: LoyaltyCarouselService,
    private _commonService: CommonService,
    private _authModalService: AuthModalService) { }

  ngOnInit(): void {
    this.isLoyaltyCardCarouselRedesignDisabled = this._aemService.getFeatureFlagByNameDisable('isLoyaltyCardCarouselRedesignDisabled');
    this.wrapper = this.elementRef.nativeElement.parentNode?.parentNode;
  }

  ngOnChanges() {
    this.coupons = this.carouselData?.dealsInfo;
    if (this.coupons && this.coupons.length > 0) {
      this._childComponentsReady.next(true);
    }
  }

  public ngAfterViewInit(): void {
    this._childComponentsReady.subscribe((next) => {
      if (next !== true) {
        return;
      }

      if (this.coupons.length === 0) {
        return;
      }

      // detect changes when coupon card is loaded
      if (this.couponCardChildComponents.length > 0) {
        this.initSlick();
        // this._carouselService.setAriaLabelForCouponCarousel(
        //   this.elementRef.nativeElement,
        //   this.couponsCarousel.carouselTitle
        // );
      } else {
        this.couponCardChildComponents.changes.subscribe(() => {
          this.initSlick();
          // this._carouselService.setAriaLabelForCouponCarousel(
          //   this.elementRef.nativeElement,
          //   this.couponsCarousel.carouselTitle
          // );
        });
      }
      if (window['AB']['DATALAYER']) {
        window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'load');
        window['AB']['DATALAYER'].initSlickArrowTracking(this.wrapper);
      }
    });
  }

  public initSlick(): void {
    const elementRef = this.elementRef.nativeElement;
    const activeSlidesL2 = {
      "320": 1,
      "695": 2,
      "767": 1,
      "920": 2,
      "1280": 3,
    };
    const activeSlides = {
      "320": 1,
      "660": 2,
      "767": 2,
      "970": 3,
      "1260": 4,
    };
    const activeSlidesPdp = {
      "660": 2,
      "767": 1,
      "1260": 2,
    };
    if(this.configObj?.appName === 'FreshPass' || this.configObj?.appName === 'weeklyAdDiscoveryPzn' || this.carouselBehaviour === "dynamic-grid-with-facets") {
      activeSlides["1260"] = 3;
    }
    const breakpointsL2 = [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: activeSlidesL2["320"],
          slidesToScroll: activeSlidesL2["320"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 695,
        settings: {
          slidesToShow: activeSlidesL2["695"],
          slidesToScroll: activeSlidesL2["695"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: activeSlidesL2["767"],
          slidesToScroll: activeSlidesL2["767"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 920,
        settings: {
          slidesToShow: activeSlidesL2["920"],
          slidesToScroll: activeSlidesL2["920"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: activeSlidesL2["1280"],
          slidesToScroll: activeSlidesL2["1280"],
          dots: false,
          arrows: true,
        },
      },
    ];

    const breakpoints = [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: activeSlides["320"],
          slidesToScroll: activeSlides["320"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 660,
        settings: {
          slidesToShow: activeSlides["660"],
          slidesToScroll: activeSlides["660"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: activeSlides["767"],
          slidesToScroll: activeSlides["767"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 970,
        settings: {
          slidesToShow: activeSlides["970"],
          slidesToScroll: activeSlides["970"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: activeSlides["1260"],
          slidesToScroll: activeSlides["1260"],
          dots: false,
          arrows: true,
        },
      },
    ];
    const breakpointsPdp = [
      {
        breakpoint: 660,
        settings: {
          slidesToShow: activeSlidesPdp["660"],
          slidesToScroll: activeSlidesPdp["660"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: activeSlidesPdp["767"],
          slidesToScroll: activeSlidesPdp["767"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: activeSlidesPdp["1260"],
          slidesToScroll: activeSlidesPdp["1260"],
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: activeSlidesPdp["1260"],
          slidesToScroll: activeSlidesPdp["1260"],
          dots: false,
          arrows: true,
        },
      },
    ];
    const pageTemplate = $("meta[name=template]")
      ? $("meta[name=template]").attr("content")
      : "";
    const pdpPageTemplates = ["unified-productdetails-page", "nextgen-pdp", "product-detail-page"];

    if ($(elementRef).find("#carousel-coupons").hasClass("slick-initialized")) {
      $(elementRef).find("#carousel-coupons").slick("unslick");
      $(elementRef).find("#carousel-coupons").removeClass("slick-initialized");
    }
    let arrow;

    $(elementRef)
      .find("#carousel-coupons")
      .not(".slick-initialized")
      .on('init', (event, slick) => {
        if(!this.isLoyaltyCardCarouselRedesignDisabled){
            this.handleShowingRedesignNavButtons();
            this._carouselService.slickChanges.next({});
        }      
     })
      .slick({
        lazyLoad: "ondemand",
        tail: true,
        dots: false,
        infinite: false,
        cssEase: "linear",
        speed: 300,
        centerMode: false,
        variableWidth: true,
        variableHeight: true,
        mobileFirst: true,
        accessibility: true,
        swipe: true,
        swipeToSlide: false,
        // prevArrow: false,//Added
        ...(this.disableSlickUnifiedBtnUI === false && {
          nextArrow:!this.isLoyaltyCardCarouselRedesignDisabled?this.nextRedesignButtonRef.nativeElement:
            `<button type="button" aria-label="${this.nextButtonAriaLabel}" class="slick-next coupons-carousel-module__next-btn"></button>`,
        }),
        ...(this.disableSlickUnifiedBtnUI === false && {
          prevArrow:!this.isLoyaltyCardCarouselRedesignDisabled?this.prevRedesignButtonRef.nativeElement:
            `<button type="button" aria-label="${this.prevButtonAriaLabel}" class="slick-prev coupons-carousel-module__prev-btn"></button>`,
        }),
        responsive:
          pageTemplate === "unified-dynamic-l2-page"
            ? breakpointsL2
            : pdpPageTemplates.indexOf(pageTemplate) > -1
            ? breakpointsPdp
            : breakpoints,
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        if (nextSlide !== 0) {
          $("#carousel-coupons .slick-prev").removeClass("mask");
        } else {
          $("#carousel-coupons .slick-prev").addClass("mask");
        }
        if(this.isCarouselRedesignDisabled){
          if (currentSlide < nextSlide) {
            // Next Button pressed
            const newSlickIndex =
              Number(
                $(".slick-active", $(elementRef)).last().attr("data-slick-index")
              ) + 1;
            const focusSlide = $(
              '.slick-list .slick-slide[data-slick-index="' +
                newSlickIndex +
                '"] .coupon-carousel-title',
              $(elementRef)
            );

            if (focusSlide) {
              setTimeout(function () {
                focusSlide.eq(0).html(focusSlide.eq(0).html()).focus();
              }, 300);
            }
            arrow = 'next';
          } else {
            // Prev Button pressed
            const newSlickIndex =
              Number(
                $(".slick-active", $(elementRef)).first().attr("data-slick-index")
              ) - 1;
            const focusSlide = $(
              '.slick-list .slick-slide[data-slick-index="' +
                newSlickIndex +
                '"] .coupon-carousel-title',
              $(elementRef)
            );

            if (focusSlide) {
              setTimeout(function () {
                focusSlide.eq(0).html(focusSlide.eq(0).html()).focus();
              }, 300);
            }
            arrow = 'prev';
          }
        } else {
          // needed to update arrow type for analytics tracking for non redesign flow
          if (currentSlide < nextSlide) {
            arrow = 'next';
          } else {
            arrow = 'prev';
          }
        }
      })
      .on('afterChange', () => {
        if(!this.isLoyaltyCardCarouselRedesignDisabled){
          this.handleShowingRedesignNavButtons();
          this._carouselService.slickChanges.next({});
       }
        
        setTimeout(() => {
           switch (arrow) {
              case 'next':
                 if (window['AB']['DATALAYER']) {
                    window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'forward');
                 }
                 break;
              case 'prev':
                 if (window['AB']['DATALAYER']) {
                    window['AB']['DATALAYER'].trackP13nCarousel(this.wrapper, this.coupons, 'back');
                 }
                 break;
              default:
                 break;
           }
        }, 0);
     });

    $("#carousel-coupons .slick-prev").addClass("mask");
  }
  public setAdaAnnouncement(announcement: string) {
    clearTimeout(this.announcementTimeout);
    this.isAdaAnnouncementEnabled = true;
    setTimeout(() => { this.adaAnnouncement = announcement }, 100)
    this.announcementTimeout = setTimeout(() => {
      this.adaAnnouncement = ''
      this.isAdaAnnouncementEnabled = false;
    }, 500);
  }

  handleShowingRedesignNavButtons() {
    this.showRedesignButtons = (window.innerWidth >= 768);
    this.isNextButtonDisabled = this.nextRedesignButtonRef.nativeElement.classList.contains('slick-disabled')
    this.isPrevButtonDisabled = this.prevRedesignButtonRef.nativeElement.classList.contains('slick-disabled')
  }

  public refreshSlickCarousel(slideIndex: number) {
  }

  public trackFn(ind: number, el: any): number {
    return ind;
  }

  public refreshTitle(updatedCoupon) {
  }

  public openRightFlyoutEvent(couponData: any) {
    this.openFlyOutEvent.emit(couponData);
  }

  public async onClickOfViewAll(event?: Event) {
    if (event) { event.preventDefault(); }

    if (this.carouselData?.webCtaProps?.popup && this._authModalService.openIfGuest(this.carouselData?.webCtaProps?.popupType)) {
      return;
    }

    if (this.configObj.appName === 'weeklyAdPzn') {
      this.viewAllClickEvent.emit();
    // Deals carousel coming from caas
    } else if ((this.carouselData?.appName == 'deals-carousel-targetted' || this.carouselData?.designType == 'dealsCarousel') && this.carouselData?.webCtaProps?.ctaLink) {
        //if deals carousel is caas and not a discovery page carousel, run experiment to determine link
        if (this.carouselData?.appName == 'deals-carousel-targetted') {
          const updatedABTestLink = await this._commonService.updateViewAllExperimentRoute();
          this.carouselData.webCtaProps.ctaLink = updatedABTestLink ? updatedABTestLink : this.carouselData.webCtaProps.ctaLink;
        }
        window['AB']?.['DATALAYER']?.analyticsCTATracking('cta:' + window['AB']?.['DATALAYER']?.initPathSections(true).join(':') + '|link|' + this.carouselData?.webCtaProps?.ctaLink)
      if (this.carouselData?.webCtaProps?.openNewTab == "true") {
        window.open(this.carouselData?.webCtaProps?.ctaLink, '_blank');
      } else {
        window.location.href = this.carouselData?.webCtaProps?.ctaLink;
      }
    }
  }

  /**
   * Getter for aria-label for deals carousel view all link.
   * Appends the carousel title to the visible CTA text so the link purpose is
   * clear out of context, e.g. "View All Weekly Ad".
   * The CTA text follows the same app-over-web precedence as the template, so
   * the announced name always starts with the label shown on screen.
   */
  public get ctaAriaLabel(): string {
    const appCtaText = this.carouselData?.appCtaProps?.ctaText;
    const webCtaText = this.carouselData?.webCtaProps?.ctaText;
    const ctaText = ((appCtaText ? appCtaText : webCtaText) || '').trim() || 'View all';
    const headline = (this.carouselData?.title || '').trim();
    return headline ? `${ctaText} ${headline}` : `${ctaText} coupons and deals`;
  }

  public get nextButtonAriaLabel(): string {
    const headline = (this.carouselData?.title || '').trim() || 'coupons and deals';
    return `Go to the next set of ${headline}`;
  }

  public get prevButtonAriaLabel(): string {
    const headline = (this.carouselData?.title || '').trim() || 'coupons and deals';
    return `Go to the previous set of ${headline}`;
  }

}
